<template>
    <div>
        <!-- 标题 -->
        <div class="dashboardHome-title">
            <Row>
                <Col span="4" style="margin-bottom: 0px;">
                    <Breadcrumb>
                        <BreadcrumbItem>{{ $t('dashboard.dashboard') }}</BreadcrumbItem>
                    </Breadcrumb>
                </Col>
                <Col span="20" style="margin-bottom: 0px;">
                    <!--按账户筛选  -->
                    <Select v-model="accountSearchKey" filterable multiple :max-tag-count="1" placeholder="" @on-change="searchAccount(accountSearchKey)" :transfer="true" style="width: 276px;float: right;margin-top: -7px;">
                        <Checkbox v-model="singleAccount" @on-change="selectAccountAll" style="display: block;text-align:right;">{{$t('alarms.common.allSelected')}}</Checkbox>
                        <Option :value="item.id" v-for="item in accountList" :key="item.id">{{item.name}}</Option>
                    </Select>
                    <!-- 按云平台筛选 -->
                     <Select v-model="accountTypeSearchKey" filterable placeholder=""  @on-change="searchAccountType" :transfer="true" style="width: 276px;float: right;margin-top: -7px;margin-right: 17px;">
                        <!-- todo 先写死 -->
                        <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
            </Row>

        </div>
        <!-- 折线图 -->
        <Row :gutter="16">
            <!-- 案例 -->
            <Col span="6">
                <Card :padding="0">
                    <Row>
                        <Col span="24" class="main-top">
                            <Row >
                                <Col class="main-top-title-left" style="z-index: 100;cursor: pointer;">
                                    <router-link :to='{ path: "/ticketCenter/case",query: { currentMonth: true,t:Date.now()}}' style="color: #fff;"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowCaseLoading"></Icon>{{numberCasesMonth}}</router-link>
                                </Col>
                                <Col class="main-top-title-right">{{ $t('dashboard.tickets') }}</Col>
                            </Row>
                            <Row>
                                <Col span="24" style="width:98%;height: 78px;margin-bottom:0px;">
                                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowEventHostLoading" style="margin-left:50%;"></Icon>
                                    <div id="event" style="width:100%;height:150px;margin-top: -49px;margin-left: -6px;"></div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span="24" class="main-bottom">
                            <Row>
                                <Col class="main-bottom-title">{{ $t('dashboard.ticket') }}</Col>
                                <Row :gutter="16">
                                    <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowCaseLoading"></Icon>
                                            <router-link :to='{ path: "/cases/keyPerformanceIndication",query: {t:Date.now()}}' style="color: #515a6e;">{{averageResponseTime}}Min</router-link>
                                            </div>
                                            <div class="allSize">{{ $t('dashboard.averageResponseTime') }}</div>
                                         </Card>
                                    </Col>
                                     <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number" >
                                                <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowCaseLoading"></Icon>
                                                <router-link :to='{ path: "/ticketCenter/case",query: { priorityId:JSON.stringify(this.priorityIdList),t:Date.now()}}' style="color: #515a6e;">{{highestAlarmCount}}</router-link>
                                            </div>
                                            <div class="allSize">{{ $t('dashboard.maximumLevel') }}</div>
                                         </Card>
                                    </Col>
                                </Row>
                            </Row>
                            <Row :gutter="16">
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.eventCreation') }}</Col>
                                    <Col span="24" class="main-bottom-bar">
                                        <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowEventWeekEventHostLoading" style="margin-left:50%;margin-top: 20%;"></Icon>
                                        <div id="eventWeek" style="width:100%;height:110px;margin-top: -49px;"></div>
                                    </Col>
                                </Col>
                                <Col span="12">
                                    <Col class="allSize">
                                          {{ $t('dashboard.currentBacklog') }}
                                    </Col>
                                    <Card class="main-bottom-content" >
                                        <Col>
                                          <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowCaseLoading"></Icon>
                                          <router-link :to='{ path: "/ticketCenter/case",query: { status:0,t:Date.now()}}' style="color: #515a6e;">{{totalBacklog}}</router-link>
                                        </Col>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <!-- 主机 -->
            <Col span="6">
                <Card :padding="0">
                    <Row>
                        <Col span="24" class="main-top" style="background-color: #e5c55f">
                            <Row>
                                <Col class="main-top-title-left"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowHostLoading"></Icon>{{instanceCount}}</Col>
                                <Col class="main-top-title-right">{{ $t('dashboard.hosts') }}</Col>
                            </Row>
                             <Row >
                                <Col span="24" style="height: 78px;margin-bottom: 0px;">
                                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowEventHostLoading" style="margin-left:50%;"></Icon>
                                    <div id="host" style="width:100%;height:150px;margin-top: -49px;margin-left: -6px;"></div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span="24" class="main-bottom">
                            <Row>
                                <Col class="main-bottom-title">{{ $t('dashboard.host') }}</Col>
                                <Row :gutter="16">
                                    <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowHostLoading"></Icon>{{instanceRunningCount}}</div>
                                            <div class="allSize">{{ $t('dashboard.running') }}</div>
                                         </Card>
                                    </Col>
                                     <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowHostLoading"></Icon>{{instanceNoRunningCount}}</div>
                                            <div class="allSize">{{ $t('dashboard.stopping') }}</div>
                                         </Card>
                                    </Col>
                                </Row>
                            </Row>
                            <Row :gutter="16">
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.hostCreation') }}</Col>
                                    <Col span="24" class="main-bottom-bar">
                                        <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowEventWeekEventHostLoading" style="margin-left:50%;margin-top: 20%;"></Icon>
                                        <div id="eventHost" style="width:100%;height:110px;margin-top: -49px;"></div>
                                    </Col>
                                </Col>
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.alarms') }}</Col>
                                    <Card class="main-bottom-content">
                                        <Col><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowHostLoading"></Icon>{{instanceAlertRuleCount}}</Col>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>

            <!-- 阿里云 安全 -->
            <Col span="6" v-show="isALY">
                <Card :padding="0">
                    <Row>
                        <Col span="24" class="main-top" style="background-color: #798ee1">
                            <Row>
                                <Col class="main-top-title-left"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowALYSecurityLoading"></Icon>{{securityScore}}</Col>
                                <Col class="main-top-title-right">{{ $t('dashboard.securityRating') }}</Col>
                            </Row>
                             <Row >
                                <Col span="24" style="height: 78px;margin-bottom: 0px;">
                                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowBugLoading" style="margin-left:50%;"></Icon>
                                    <div id="bug" style="width:100%;height:150px;margin-top: -49px;margin-left: -6px;"></div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span="24" class="main-bottom">
                            <Row>
                                <Col class="main-bottom-title">{{ $t('dashboard.security') }}</Col>
                                <Row :gutter="16">
                                    <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowALYSecurityLoading"></Icon>{{totalRiskCount}}</div>
                                            <div class="allSize">{{ $t('dashboard.totalRisks') }}</div>
                                         </Card>
                                    </Col>
                                     <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowALYSecurityLoading"></Icon>{{highRiskLevelCount}}</div>
                                            <div class="allSize">{{ $t('dashboard.highRisks') }}</div>
                                         </Card>
                                    </Col>
                                </Row>
                            </Row>
                            <Row :gutter="16">
                                 <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.baselineProblems') }}</Col>
                                    <Card class="main-bottom-content">
                                        <Col><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowALYSecurityLoading"></Icon>{{checkWarningCount}}</Col>
                                    </Card>
                                </Col>
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.holes') }}</Col>
                                    <Card class="main-bottom-content">
                                        <Col><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowALYSecurityLoading"></Icon>{{vulCount}}</Col>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <!-- 阿里云 花费 -->
            <Col span="6" v-show="isALY">
                <Card :padding="0">
                    <Row>
                        <Col span="24" class="main-top" style="background-color: #5fc27e">
                            <Row>
                                <Col class="main-top-title-left"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSALYSumCostLoading"></Icon>{{sumCost}}</Col>
                                <Col class="main-top-title-right">{{ $t('dashboard.sumCost') }}</Col>
                            </Row>
                             <Row >
                                <Col span="24" style="height: 78px;margin-bottom: 0px;">
                                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowSpendLoading" style="margin-left:50%;"></Icon>
                                    <div id="spend" style="width:100%;height:150px;margin-top: -49px;margin-left: -6px;"></div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span="24" class="main-bottom">
                            <Row>
                                <Col class="main-bottom-title">{{ $t('dashboard.cost') }}</Col>
                                <Row :gutter="16">
                                    <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number">￥<Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSALYCurrentCostLoading"></Icon>{{currentCost}}</div>
                                            <div class="allSize">{{ $t('dashboard.currentCost') }}</div>
                                         </Card>
                                    </Col>
                                     <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number">￥<Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowALYcumulativeExpenditureYear"></Icon>{{cumulativeExpenditureYear}}</div>
                                            <div class="allSize">{{ $t('dashboard.cumulative') }}</div>
                                         </Card>
                                    </Col>
                                </Row>
                            </Row>
                            <Row :gutter="16">
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.recharge') }}</Col>

                                    <Card class="main-bottom-content">
                                        <Tooltip>
                                            <Col>￥<Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowALYlastRecharge"></Icon>{{lastRecharge}}</Col>
                                            <div slot="content">
                                                <p>
                                                    <p>{{ $t('dashboard.date') }}</p>
                                                    <p>{{lastRechargeTime}}</p>
                                                </p>
                                            </div>
                                        </Tooltip>
                                    </Card>
                                </Col>
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.balance') }}</Col>
                                    <Card class="main-bottom-content">
                                        <Col>￥<Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowALYAccountBalance"></Icon>{{accountBalance}}</Col>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>

            <!-- AWS 日志 -->
            <Col span="6" v-show="isAWS">
                <Card :padding="0">
                    <Row>
                        <Col span="24" class="main-top" style="background-color: #798ee1">
                            <Row>
                                <Col class="main-top-title-left"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSCreateEventNumLoading"></Icon>{{createEventNum}}</Col>
                                <Col class="main-top-title-right">{{ $t('dashboard.resourceCreated') }}</Col>
                            </Row>
                             <Row >
                                <Col span="24" style="height: 78px;margin-bottom: 0px;">
                                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowResourceDeleteLoading" style="margin-left:50%;"></Icon>
                                    <div id="resourceDelete" style="width:100%;height:150px;margin-top: -49px;margin-left: -6px;"></div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span="24" class="main-bottom">
                            <Row>
                                <Col class="main-bottom-title">{{ $t('dashboard.log') }}</Col>
                                <Row :gutter="16">
                                    <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSRejectCountLoading"></Icon>{{rejectCount}}</div>
                                            <div class="allSize">{{ $t('dashboard.netRejection') }}</div>
                                         </Card>
                                    </Col>
                                     <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSDeleteEventNumLoading"></Icon>{{deleteEventNum}}</div>
                                            <div class="allSize">{{ $t('dashboard.resourceDeletion') }}</div>
                                         </Card>
                                    </Col>
                                </Row>
                            </Row>
                            <Row :gutter="16">
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.resourceChange') }}</Col>
                                    <Col span="24" class="main-bottom-bar">
                                        <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowEventResourceLoading" style="margin-left:50%;margin-top: 20%;"></Icon>
                                        <div id="eventResource" style="width:100%;height:110px;margin-top: -49px;"></div>
                                    </Col>
                                </Col>
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.exceptionRequest') }}</Col>
                                    <Card class="main-bottom-content">
                                        <Col><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSExceptionNumLoading"></Icon>{{exceptionNum}}</Col>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <!-- AWS 花费 -->
            <Col span="6" v-show="isAWS">
                <Card :padding="0">
                    <Row>
                        <Col span="24" class="main-top" style="background-color: #5fc27e">
                            <Row>
                                <Col class="main-top-title-left"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSALYSumCostLoading"></Icon>{{sumCost}}</Col>
                                <Col class="main-top-title-right">{{ $t('dashboard.sumCost') }}</Col>
                            </Row>
                             <Row >
                                <Col span="24" style="height: 78px;margin-bottom: 0px;">
                                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowSpendAWSLoading" style="margin-left:50%;"></Icon>
                                    <div id="spendAWS" style="width:100%;height:150px;margin-top: -49px;margin-left: -6px;"></div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span="24" class="main-bottom">
                            <Row>
                                <Col class="main-bottom-title">{{ $t('dashboard.cost') }}</Col>
                                <Row :gutter="16">
                                    <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number">￥<Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSALYCurrentCostLoading"></Icon>{{currentCost}}</div>
                                            <div class="allSize">{{ $t('dashboard.currentCost') }}</div>
                                         </Card>
                                    </Col>
                                     <Col span="12">
                                        <Card class="main-second-title">
                                            <div class="main-bottom-number">￥<Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSPredictCostLoading"></Icon>{{predictCost}}</div>
                                            <div class="allSize">{{ $t('dashboard.expected') }}</div>
                                         </Card>
                                    </Col>
                                </Row>
                            </Row>
                            <Row :gutter="16">
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.noMatchRI') }}</Col>
                                    <Col span="24" class="main-bottom-bar">
                                        <Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowEventSpendLoading" style="margin-left:50%;margin-top: 20%;"></Icon>
                                        <div id="eventSpend" style="width:100%;height:110px;margin-top: -49px;"></div>
                                    </Col>
                                </Col>
                                <Col span="12">
                                    <Col class="allSize">{{ $t('dashboard.rISaving') }}</Col>
                                    <Card class="main-bottom-content">
                                        <Col>￥<Icon type="ios-loading" size=18 class="demo-spin-icon-load" v-show="isShowAWSRiSaveCostLoading"></Icon>{{riSaveCost}}</Col>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>

            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col>
                            <Row>
                                <Col span="12" class="title">{{ $t('dashboard.spendingThan') }}</Col>
                                <!--按标签筛选  -->
                                <Col style="width:150px;float:right;margin-left: 10px;margin-top: 5px;">
                                    <Select v-model="tag" @on-change="changeTag()" placeholder="按标签筛选">
                                        <Option :value="item.id" v-for="item in tags" :key="item.id">{{item.name}}</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <div id="spendbyDimension" style="width:100%;height: 222px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="12">
                <Row>
                    <Col>
                        <Table :no-data-text="$t('common.noData')" height="277" :columns="columns" :data="tableCurrentBudgetInstanceListDate"></Table>
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../utils/cookieUtil.js'
    import TableCase from '../cases/case/TableCase'
    var tableCase = TableCase;
    export default {
        name: 'dashboardHome',
        inject: ['reload'],
        data () {
            return {
                priorityIdList:[0],
                isShowSpendLoading:true,
                isShowBugLoading:true,
                isShowSpendAWSLoading:true,
                isShowEventSpendLoading:true,
                isShowEventResourceLoading:true,
                isShowResourceDeleteLoading:true,
                isShowEventHostLoading:true,
                isShowEventWeekEventHostLoading:true,
                isShowALYAccountBalance:true,
                isShowALYlastRecharge:true,
                isShowALYcumulativeExpenditureYear:true,
                isShowALYSecurityLoading:true,
                isShowAWSRiSaveCostLoading:true,
                isShowAWSPredictCostLoading:true,
                isShowAWSALYCurrentCostLoading:true,
                isShowAWSALYSumCostLoading:true,
                isShowAWSExceptionNumLoading:true,
                isShowAWSRejectCountLoading:true,
                isShowAWSCreateEventNumLoading:true,
                isShowHostLoading:true,
                isShowCaseLoading:true,
                isShowAWSDeleteEventNumLoading:true,
                isAWS:false,
                isALY:false,
                lastRechargeTime:'',
                accountTypeSearchKey:'',
                accountTypeList:[],
                accountSearchKey:[],
                singleAccount:false,
                accountList:[],
                //实例主机
                instanceRunningCount:"",
                instanceNoRunningCount:"",
                instanceCount:"",
                instanceAlertRuleCount:"",
                //案例
                numberCasesMonth:"",
                averageResponseTime:"",
                highestAlarmCount:'',
                totalBacklog:"",
                // 安全
                securityScore:"",
                totalRiskCount:"",
                highRiskLevelCount:"",
                checkWarningCount:"",
                vulCount:"",
                // 日志
                rejectCount:"",
                exceptionNum:"",
                deleteEventNum:"",
                createEventNum:"",
                chartResourceDelete:"",
                // echarts实例
                chartSpendbyDimension:'',
                chartEventWeek:'',
                chartEventHost:'',
                chartSpend:'',
                chartBug:'',
                chartEvent:'',
                chartHost:'',
                chartSpendAWS:'',
                chartEventResource:'',
                // 数组
                deleteEventsCountList:[],
                deleteEventsXaxes:[],
                xaxes:[],
                eventWeekY:[],
                eventHostY:[],
                xaxesLine:[],
                eventY:[],
                hostY:[],
                accountCost:[],
                creationDate:[],
                dateListXaxes:[],
                updateEventsCountList:[],
                currentCost:'',
                predictCost:'',
                riSaveCost:'',
                cumulativeExpenditureYear:'',
                lastRecharge:'',
                chartEventSpend:'',
                dateList:[],
                alarmEventY:[],
                alarmXaxes:[],
                notOtherLinuxList:[],
                otherLinuxList:[],
                expenditureShares:[],
                newExpenditureSharesList:[],
                accountBalance:'',
                sumCost:'',
                tags:[],
                tag:'',
                columns: [
                {
                    title: this.$t('dashboard.theme'),
                    key: 'ticketEntityId',
                    width:150
                },
                {
                    title: this.$t('dashboard.resource'),
                    key: 'monitorModuleName'
                },
                {
                    title: this.$t('dashboard.priority'),
                    key: 'priorityName'
                },
                {
                    title: this.$t('dashboard.modifiedTime'),
                    key: 'modifiedTime'
                },
                {
                    title:this.$t('dashboard.status'),
                    key: 'statusName'
                }],
                tableCurrentBudgetInstanceListDate:[]
            }
        },
        mounted: function(){
            this.getAccountType();
            this.selectAccountByCloudPlatform();
            this.getTags();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartSpendbyDimension.resize();
                self.chartEvent.resize();
                self.chartEventWeek.resize();
                self.chartEventHost.resize();
                self.chartHost.resize();
                self.chartBug.resize();
                self.chartSpend.resize();
                self.chartEventSpend.resize();
                self.chartSpendAWS.resize();
                self.chartEventResource.resize();
                self.chartResourceDelete.resize();
            });
        },
        methods: {
            /******************案例和主机loading(AWS&阿里云)*****************/
            showCaseHostLoading:function(){
                //实例主机
                this.instanceRunningCount='';
                this.instanceNoRunningCount='';
                this.instanceCount='';
                this.instanceAlertRuleCount='';
                //案例
                this.numberCasesMonth='';
                this.averageResponseTime='';
                this.highestAlarmCount='';
                this.totalBacklog='';
                this.isShowHostLoading=true;
                this.isShowCaseLoading=true;
                // 案例和主机柱状图
                // 清空画布
                this.$echarts.init(document.getElementById("eventWeek")).clear();
                this.xaxes=[];
                this.eventWeekY=[];
                this.$echarts.init(document.getElementById("eventHost")).clear();
                this.xaxes=[];
                this.eventHostY=[];
                this.isShowEventWeekEventHostLoading=true;
                // 案例和主机折线图
                // 清空画布
                this.$echarts.init(document.getElementById("event")).clear();
                this.xaxesLine=[];
                this.eventY=[];
                this.$echarts.init(document.getElementById("host")).clear();
                this.xaxesLine=[];
                this.hostY=[];
                this.isShowEventHostLoading=true;
            },
            /******************日志和花费Loading(AWS)***********************/
            showAWSLogCostLoading:function(){
                // 日志
                this.rejectCount='';
                this.exceptionNum='';
                this.deleteEventNum='';
                this.createEventNum='';
                // 花费
                this.sumCost='';
                this.currentCost='';
                this.predictCost='';
                this.riSaveCost='';
                this.isShowAWSRiSaveCostLoading=true;
                this.isShowAWSPredictCostLoading=true;
                this.isShowAWSALYCurrentCostLoading=true;
                this.isShowAWSALYSumCostLoading=true;
                this.isShowAWSExceptionNumLoading=true;
                this.isShowAWSRejectCountLoading=true;
                this.isShowAWSCreateEventNumLoading=true;
                this.isShowAWSDeleteEventNumLoading=true;
                // 日志柱状图
                // 清空画布
                this.$echarts.init(document.getElementById("eventResource")).clear();
                this.dateListXaxes=[];
                this.updateEventsCountList=[];
                this.isShowEventResourceLoading=true;
                // 日志折线图
                // 清空画布
                this.$echarts.init(document.getElementById("resourceDelete")).clear();
                this.deleteEventsXaxes=[];
                this.deleteEventsCountList=[];
                this.isShowResourceDeleteLoading=true;
                // 花费柱状图
                // 清空画布
                this.$echarts.init(document.getElementById("eventSpend")).clear();
                this.dateList=[];
                this.otherLinuxList=[];
                this.notOtherLinuxList=[];
                this.isShowEventSpendLoading=true;
                // 花费折线图
                // 清空画布
                this.$echarts.init(document.getElementById("spendAWS")).clear();
                this.creationDate=[];
                this.accountCost=[];
                this.isShowSpendAWSLoading=true;
            },
            /******************安全Loading(阿里云)***********************/
            showALYSecurityLoading:function(){
                // 安全
                this.securityScore='';
                this.totalRiskCount='';
                this.highRiskLevelCount='';
                this.checkWarningCount='';
                this.vulCount='';
                this.isShowALYSecurityLoading=true;
                // 安全折线图
                // 清空画布
                this.$echarts.init(document.getElementById("bug")).clear();
                this.alarmXaxes=[];
                this.alarmEventY=[];
                this.isShowBugLoading=true;
            },
            /******************花费Loading(阿里云)***********************/
            showALYCostLoading:function(){
                // 花费
                this.sumCost='';
                this.currentCost='';
                this.cumulativeExpenditureYear='';
                this.lastRecharge='';
                this.accountBalance='';
                this.isShowAWSALYSumCostLoading=true;
                this.isShowAWSALYCurrentCostLoading=true;
                this.isShowALYcumulativeExpenditureYear=true;
                this.isShowALYlastRecharge=true;
                this.isShowALYAccountBalance=true;
                // 花费折线图
                // 清空画布
                this.$echarts.init(document.getElementById("spend")).clear();
                this.creationDate=[];
                this.accountCost=[];
                this.isShowSpendLoading=true;
            },
            /******************接口********************************/
            //查询云平台
            getAccountType: function(){
                this.$api.account.queryCloudPlatformsByCurrentUser("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.accountTypeList = res.data;
                        this.accountTypeSearchKey=this.accountTypeList[0].id;
                        this.selectAccountByCloudPlatform();
                        if(this.accountTypeSearchKey==0){
                            this.isAWS=true;
                            this.isALY=false;
                        }else if(this.accountTypeSearchKey==1 || this.accountTypeSearchKey==5){
                            this.isALY=true;
                            this.isAWS=false;
                        }
                    })
            },
            // 按云平台筛选
            searchAccountType: function(){
                /*********案例和主机Loading(AWS&阿里云)*********/
                this.getTags();
                this.showCaseHostLoading();
                this.accountSearchKey=[];
                this.selectAccountByCloudPlatform();
                if(this.accountTypeSearchKey==0){
                    /*********日志和花费Loading(AWS)*********/
                    this.showAWSLogCostLoading();
                    // 显示AWS
                    this.isAWS=true;
                    this.isALY=false;
                }else if(this.accountTypeSearchKey==1 || this.accountTypeSearchKey==5){
                    /*********安全Loading(阿里云)*********/
                    this.showALYSecurityLoading();
                    /*********花费Loading(阿里云)*********/
                    this.showALYCostLoading();
                    this.isALY=true;
                    this.isAWS=false;
                }

            },
            //查询云平台下所有账户
            selectAccountByCloudPlatform: function(){
                this.$api.account.selectAccountByCloudPlatform("type",this.accountTypeSearchKey)
                    .then(res => {
                        this.accountList = res.data;
                        if (this.accountList.length <= 0) {
                          this.searchAccount([])
                        } else {
                          for(var i=0;i<this.accountList.length;i++){
                            // 如果是阿里云全选 其余默认选中第一个
                            if(this.accountTypeSearchKey==0){
                              this.accountSearchKey=this.accountList[0].id;
                            }else if(this.accountTypeSearchKey==1){
                              this.accountSearchKey.push(this.accountList[i].id);
                            }else if(this.accountTypeSearchKey==2){
                              this.accountSearchKey=this.accountList[0].id;
                            }else if(this.accountTypeSearchKey==5){
                              this.accountSearchKey=this.accountList[0].id;
                            }
                          }
                        }
                    })
            },
            /***********账户**************************/
            selectAccountAll(){
                this.accountSearchKey = []
                if (this.singleAccount) {
                    this.accountList.map((item) => {
                        this.accountSearchKey.push(item.id)
                    })
                } else {
                    this.accountSearchKey = []
                }
            },
            // 切换账户
            searchAccount:function(val){
                if (val.length === this.accountList.length&&val.length!=0) {
                    this.singleAccount = true
                } else {
                    this.singleAccount = false
                }
                setTimeout(()=>{
                    if (this.accountTypeSearchKey == 0) {
                        // AWS
                        /*********日志和花费Loading(AWS)*********/
                        this.showAWSLogCostLoading();
                        // 调用日志和花费
                        this.getRiSaveCost();
                        this.getSumCost();
                        this.getCurrentCost();
                        this.getPredictCost();
                        this.logHistogram();
                        this.logLineChart();
                        this.networkAccessDeniedNum();
                        this.networkAccessExceptionNum();
                        this.deleteEventNums();
                        this.createEventNums();
                    } else if (this.accountTypeSearchKey == 1 || this.accountTypeSearchKey == 5){
                        // Aliyun或者hwc
                        /*********安全Loading(阿里云)*********/
                        this.showALYSecurityLoading();
                        /*********花费Loading(阿里云)*********/
                        this.showALYCostLoading();

                        this.getSumCost();
                        this.getCurrentCost();
                        this.getPredictCost();
                        this.getAccountBalance();
                        this.getCumulativeExpenditureYear();
                        this.getLastRecharge();
                        this.securityDashboard();
                        this.securityLineChart();
                    } else {
                        // Azure 财务模块 暂时还没做
                        this.currentCost= 0;
                        this.predictCost= 0;
                        this.riSaveCost= 0;
                        this.cumulativeExpenditureYear=0;
                        this.accountBalance= 0;
                        this.lastRecharge= 0;
                        this.lastRechargeTime= 0;
                        this.sumCost= 0;
                    }
                    /*********案例和主机Loading(AWS&阿里云)*********/
                    this.showCaseHostLoading();
                    // 调用案例和主机等
                    this.backlogPage();
                    this.ticket();
                    this.instance();
                    this.histogram();
                    this.lineChart();
                    this.financePieChart();
                    this.financeLineChart();
                    this.financeHistogram();
                }, 500)
            },
            // 待办事项
            backlogPage:function() {
                this.$api.instrumentPanel.backlogPage({
                    "accountIdList":this.accountSearchKey
                })
                .then(res => {
                    this.tableCurrentBudgetInstanceListDate = res.data.records || 0;
                })
            },
            // 仪表盘案例模块
            ticket: function(){
                this.$api.instrumentPanel.ticket({
                    "accountIdList":this.accountSearchKey
                })
                    .then(res => {
                        this.highestAlarmCount=res.data.highestAlarmCount || 0;
                        this.totalBacklog=res.data.totalBacklog || 0;
                        this.averageResponseTime=res.data.averageResponseTime || 0;
                        this.numberCasesMonth=res.data.numberCasesMonth || 0;
                    }).finally(() => {
                  this.isShowCaseLoading=false;
                })
            },
              // 仪表盘主机模块
            instance: function(){
                this.$api.instrumentPanel.instance({
                    "accountIdList":this.accountSearchKey
                })
                .then(res => {
                    this.instanceRunningCount=res.data.instanceRunningCount || 0;
                    this.instanceNoRunningCount=res.data.instanceNoRunningCount || 0;
                    this.instanceCount=res.data.instanceCount || 0;
                    this.instanceAlertRuleCount=res.data.instanceAlertRuleCount || 0;
                }).finally(() => {
                  this.isShowHostLoading=false;
                })
            },
            // 主机和案例的柱状图
            histogram: function(){
                this.$api.instrumentPanel.histogram({
                    "accountIdList":this.accountSearchKey
                })
                    .then(res => {
                        this.xaxes=res.data.xaxes;
                        // 案例柱状图
                        this.eventWeekY=res.data.ticketY;
                        // 主机柱状图
                        this.eventHostY=res.data.instanceY;
                        this.init();
                    }).finally(() => {
                  this.isShowEventWeekEventHostLoading=false;
                })
            },
           //主机和案例的折线图
            lineChart: function(){
                this.$api.instrumentPanel.lineChart({
                  "accountIdList":this.accountSearchKey
                })
                .then(res => {
                    this.xaxesLine=res.data.xaxes;
                    // 案例折线图
                    this.eventY=res.data.ticketY;
                    // 主机折线图
                    this.hostY=res.data.instanceY;
                    this.init();
                }).finally(() => {
                  this.isShowEventHostLoading=false;
                })
            },
            // RI节省
            getRiSaveCost: function(){
                this.$api.instrumentPanel.getRiSaveCost({
                    "accountId":this.accountSearchKey
                })
                    .then(res => {
                        // 本月RI节省
                        this.riSaveCost=res.data || 0;
                    }).finally(() => {
                  this.isShowAWSRiSaveCostLoading=false;
                })
            },
            // 财务汇总
            getSumCost: function(){
                this.$api.instrumentPanel.getSumCost({
                    "accountId":this.accountSearchKey
                })
                    .then(res => {
                        // 财务汇总
                        this.sumCost=res.data || 0;
                    }).finally(() => {
                  this.isShowAWSALYSumCostLoading=false;
                })
            },
            // 本月当前花费
            getCurrentCost: function(){
                this.$api.instrumentPanel.getCurrentCost({
                    "accountId":this.accountSearchKey
                })
                    .then(res => {
                        // 本月当前花费
                        this.currentCost=res.data || 0;
                    }).finally(() => {
                  this.isShowAWSALYCurrentCostLoading=false;
                })
            },
            // 本月预计费用
            getPredictCost: function(){
                this.$api.instrumentPanel.getPredictCost({
                    "accountId":this.accountSearchKey
                })
                    .then(res => {
                        // 本月当前花费
                        this.predictCost=res.data || 0;
                    }).finally(() => {
                  this.isShowAWSPredictCostLoading=false;
                })
            },
            // 今年累计花费
            getCumulativeExpenditureYear: function(){
                this.$api.instrumentPanel.getCumulativeExpenditureYear({
                    "accountId":this.accountSearchKey
                })
                    .then(res => {
                        // 今年累计花费
                        this.cumulativeExpenditureYear=res.data || 0;
                    }).finally(() => {
                  this.isShowALYcumulativeExpenditureYear=false;
                })
            },
            // 账户余额
            getAccountBalance: function(){
                this.$api.instrumentPanel.getAccountBalance({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // 账户余额
                    this.accountBalance=res.data || 0;
                }).finally(() => {
                  this.isShowALYAccountBalance=false;
                })
            },
            // 上次充值金额
            getLastRecharge: function(){
                this.$api.instrumentPanel.getLastRecharge({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // 充值金额
                    this.lastRecharge=res.data.lastRecharge || 0;
                    // 充值时间
                    this.lastRechargeTime=res.data.lastRechargeTime;
                }).finally(() => {
                  this.isShowALYlastRecharge=false;
                })
            },
            //财务折线图
            financeLineChart: function(){
                this.$api.instrumentPanel.financeLineChart({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // Y轴
                    this.accountCost=res.data.accountCost;
                    // 年月日
                    this.creationDate=res.data.creationDate;
                    this.init();
                }).finally(() => {
                  this.isShowSpendAWSLoading=false;
                  this.isShowSpendLoading=false;
                })
            },
            //财务柱状图
            financeHistogram: function(){
                this.$api.instrumentPanel.financeHistogram({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // 年月日
                    this.dateList=res.data.dateList;
                    this.notOtherLinuxList=res.data.notOtherLinuxList;
                    this.otherLinuxList=res.data.otherLinuxList;
                    this.init();
                }).finally(() => {
                  this.isShowEventSpendLoading=false;
                })
            },
            //财务饼图
            financePieChart: function(){
                this.$api.instrumentPanel.financePieChart({
                    "accountId":this.accountSearchKey,
                    "tag": this.tag
                })
                    .then(res => {
                        this.expenditureShares=res.data.expenditureShares;
                        if(this.expenditureShares==undefined){
                            return;
                        }
                        for(var i=0;i<this.expenditureShares.length;i++){
                            var ExpenditureSharesCopy = new Object();
                            ExpenditureSharesCopy.name = this.expenditureShares[i].name;
                            this.newExpenditureSharesList.push(ExpenditureSharesCopy);
                        }
                        this.totalCost=res.data.totalCost;
                        this.init();
                    })
            },
            //安全仪表盘
            securityDashboard: function(){
                this.$api.instrumentPanel.securityDashboard({
                    "accountId":this.accountSearchKey
                })
                    .then(res => {
                        // 安全评分
                        this.securityScore=res.data.securityScore || 0;
                        // 总风险数量
                        this.totalRiskCount=res.data.totalRiskCount || 0;
                        // 高风险等级数量
                        this.highRiskLevelCount=res.data.highRiskLevelCount || 0;
                        // 基线问题数量
                        this.checkWarningCount=res.data.checkWarningCount || 0;
                        // 漏洞数量
                        this.vulCount=res.data.vulCount || 0;
                    }).finally(() => {
                  this.isShowALYSecurityLoading=false;
                })
            },
            //安全折线图
            securityLineChart: function(){
                this.$api.instrumentPanel.securityLineChart({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // Y轴
                    this.alarmEventY=res.data.alarmEventY;
                    // 年月日
                    this.alarmXaxes=res.data.xaxes;
                    this.init();
                }).finally(() => {
                  this.isShowBugLoading=false;
                })
            },
            /*******************日志**************************************/
            //日志仪表盘
            // 网络访问拒绝
            networkAccessDeniedNum: function(){
                this.$api.instrumentPanel.networkAccessDeniedNum({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // 网络访问拒绝
                    this.rejectCount=res.data.rejectCount || 0;
                }).finally(() => {
                  this.isShowAWSRejectCountLoading=false;
                })
            },
            // 本月异常请求总数
            networkAccessExceptionNum: function(){
                this.$api.instrumentPanel.networkAccessExceptionNum({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // 本月异常请求总数
                    this.exceptionNum=res.data.exceptionNum || 0;
                }).finally(() => {
                  this.isShowAWSExceptionNumLoading=false;
                })
            },
            // 资源删除
            deleteEventNums: function(){
                this.$api.instrumentPanel.deleteEventNum({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // 资源删除
                    this.deleteEventNum=res.data.deleteEventNum || 0;
                }).finally(() => {
                  this.isShowAWSDeleteEventNumLoading=false;
                })
            },
            // 资源创建数量
            createEventNums: function(){
                this.$api.instrumentPanel.createEventNum({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // 资源创建数量
                    this.createEventNum=res.data.createEventNum || 0;
                }).finally(() => {
                  this.isShowAWSCreateEventNumLoading=false;
                })
            },
            //日志折线图
            logLineChart: function(){
                this.$api.instrumentPanel.logLineChart({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // Y轴
                    this.deleteEventsCountList=res.data.deleteEventsCountList;
                    // 年月日
                    this.deleteEventsXaxes=res.data.xaxes;
                    this.init();
                }).finally(() => {
                  this.isShowResourceDeleteLoading=false;
                })
            },
            //日志柱状图
            logHistogram: function(){
                this.$api.instrumentPanel.logHistogram({
                    "accountId":this.accountSearchKey
                })
                .then(res => {
                    // 年月日
                    this.dateListXaxes=res.data.xaxes;
                    this.updateEventsCountList=res.data.updateEventsCountList;
                    this.init();
                }).finally(() => {
                  this.isShowEventResourceLoading=false;
                })
            },
            /******************所有图表********************************/
            init:function(){
                setTimeout(()=>{
                    this.spendbyDimensionLine();
                    this.eventWeekLine();
                    this.eventHostLine();
                    this.eventLine();
                    this.hostLine();
                    this.bugLine();
                    this.spendLine();
                    this.eventSpendLine();
                    this.spendAWSLine();
                    this.eventResourceLine();
                    this.resourceDeleteLine();
                })
            },
            // 各维度花费比例
            spendbyDimensionLine:function(){
                this.chartSpendbyDimension=this.$echarts.init(document.getElementById("spendbyDimension"));
                this.chartSpendbyDimension.setOption({
                    tooltip : {
                        trigger: 'item',
                        // formatter: "{a} <br/>{b} : {c} ({d}%)"
                      formatter: (params) => {
                        return `${params.name}: ${this.$echarts.format.addCommas(params.value)}(${params.percent}%)`;
                      }
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data:this.newExpenditureSharesList
                    },
                    grid: {
                        top:'5%'
                    },
                    color:['#47bac1', '#e5c55f','#798ee1','#ccc'],
                    series : [
                        {
                            name: '支出占比',
                            type: 'pie',
                            radius : '85%',
                            center: ['55%', '50%'],
                            label: {
                                normal: {
                                    show: false
                                },
                            },
                            data:this.expenditureShares,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })

            },
            /*****************柱状图***************************/
            // 事件创建
            eventWeekLine:function(){
                var that = this;
                this.chartEventWeek=this.$echarts.init(document.getElementById("eventWeek"));
                this.chartEventWeek.on('click',function (param) {
                    that.$router.push({
                        path: '/ticketCenter/case',
                        query: { createdTime: param.name,t:Date.now() }
                    });
                })
                this.chartEventWeek.setOption({
                    color: ['#47bac1'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {
                            type : 'shadow'
                        },
                        confine: true
                    },
                    grid: {
                        left: '0%',
                        right: '15%',
                        bottom: '3%'
                    },
                    xAxis: {
                        type: 'category',
                        show : false,
                        data: this.xaxes
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [{
                        name:'事件总数',
                        type:'bar',
                        barGap:'80%',
                        barWidth: '40%',
                        barMinHeight:1,
                        data:this.eventWeekY
                    }]
                });
            },
            // 一周主机创建
            eventHostLine:function(){
                this.chartEventHost=this.$echarts.init(document.getElementById("eventHost"));
                this.chartEventHost.setOption({
                    color: ['#e5c55f'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {
                            type : 'shadow'
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '15%',
                        bottom: '3%'
                    },
                    xAxis: {
                        type: 'category',
                        show : false,
                        data: this.xaxes
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [{
                        name:'启动总数',
                        type:'bar',
                        barGap:'80%',
                        barWidth: '40%',
                        barMinHeight:1,
                        data:this.eventHostY
                    }]
                });
            },
            // 一周资源更新
            eventResourceLine:function(){
                this.chartEventResource=this.$echarts.init(document.getElementById("eventResource"));
                this.chartEventResource.setOption({
                    color: ['#798ee1'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {
                            type : 'shadow'
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '15%',
                        bottom: '3%'
                    },
                    xAxis: {
                        type: 'category',
                        show : false,
                        data: this.dateListXaxes
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [{
                        name:'资源变更总数',
                        type:'bar',
                        barGap:'80%',
                        barWidth: '40%',
                        barMinHeight:1,
                        data:this.updateEventsCountList
                    }]
                });

            },
             // 未匹配RI
            eventSpendLine:function(){
                this.chartEventSpend=this.$echarts.init(document.getElementById("eventSpend"));
                this.chartEventSpend.setOption({
                    color: ['#5fc27e'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {
                            type : 'shadow'
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '2%',
                        bottom: '3%'
                    },
                    xAxis: {
                        type: 'category',
                        show : false,
                        data: this.dateList
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [{
                        name:'单元',
                        type:'bar',
                        stack: 'two',
                        barGap:'80%',
                        barWidth: '40%',
                        barMinHeight:1,
                        data:this.otherLinuxList
                    },{
                        name:'数量',
                        type:'bar',
                        stack: 'two',
                        barGap:'80%',
                        barWidth: '40%',
                        barMinHeight:1,
                        data:this.notOtherLinuxList
                    }]
                });
            },
            /*****************折线图***************************/
            // 事件总数
            eventLine:function(){
                var that = this;
                this.chartEvent=this.$echarts.init(document.getElementById("event"));
                this.chartEvent.on('click',function (param) {
                    that.$router.push({
                        path: '/ticketCenter/case',
                        query: { createdTime: param.name,t:Date.now() }
                    });
                })
                this.chartEvent.setOption({
                    color: ['#fff'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer : {
                            type : ''
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        show : false,
                        type: 'category',
                        boundaryGap: false,
                        data: this.xaxesLine
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [
                        {
                            name:'事件总数',
                            type:'line',
                            stack: '总量',
                            data:this.eventY
                        }
                    ]
                });
            },
            // 资源删除
            resourceDeleteLine:function(){
                this.chartResourceDelete=this.$echarts.init(document.getElementById("resourceDelete"));
                this.chartResourceDelete.setOption({
                    color: ['#fff'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer : {
                            type : ''
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        show : false,
                        type: 'category',
                        boundaryGap: false,
                        data: this.deleteEventsXaxes
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [
                        {
                            name:'资源删除',
                            type:'line',
                            stack: '总量',
                            data:this.deleteEventsCountList
                        }
                    ]
                });
            },
            // 主机创建
            hostLine:function(){
                this.chartHost=this.$echarts.init(document.getElementById("host"));
                this.chartHost.setOption({
                    color: ['#fff'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer : {
                            type : ''
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        show : false,
                        type: 'category',
                        boundaryGap: false,
                        data: this.xaxesLine
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [
                        {
                            name:'创建主机总数',
                            type:'line',
                            stack: '总量',
                            data:this.hostY
                        }
                    ]
                });
            },
            // 告警事件
            bugLine:function(){
                this.chartBug=this.$echarts.init(document.getElementById("bug"));
                this.chartBug.setOption({
                    color: ['#fff'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer : {
                            type : ''
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        show : false,
                        type: 'category',
                        boundaryGap: false,
                        data: this.alarmXaxes
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [
                        {
                            name:'告警事件',
                            type:'line',
                            stack: '总量',
                            data:this.alarmEventY
                        }
                    ]
                });
            },
            // 未匹配RI 阿里云
            spendLine:function(){
                this.chartSpend=this.$echarts.init(document.getElementById("spend"));
                this.chartSpend.setOption({
                    color: ['#fff'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer : {
                            type : ''
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        show : false,
                        type: 'category',
                        boundaryGap: false,
                        data: this.creationDate
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [
                        {
                            name:'日花费',
                            type:'line',
                            stack: '总量',
                            data:this.accountCost
                        }
                    ]
                });
            },
            // 未匹配RI AWS
            spendAWSLine:function(){
                this.chartSpendAWS=this.$echarts.init(document.getElementById("spendAWS"));
                this.chartSpendAWS.setOption({
                    color: ['#fff'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer : {
                            type : ''
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        show : false,
                        type: 'category',
                        boundaryGap: false,
                        data: this.creationDate
                    },
                    yAxis: {
                        show : false,
                        type: 'value'
                    },
                    series: [
                        {
                            name:'费用累计值',
                            type:'line',
                            stack: '总量',
                            data:this.accountCost
                        }
                    ]
                });
            },
            // 获取标签
            getTags:function(){
              const data = {
                userName: getCookie(global.cookieName),
                accountType: this.accountTypeSearchKey || 0
              }
                this.$api.instrumentPanel.getTags(data)
                .then(res => {
                    this.tags = res.data;
                    this.tag=this.tags[0].id;
                })
            },
            // 标签值改变事件
            changeTag:function(){
              this.financePieChart();
            }

        }
    }
</script>

<style scoped>
    .dashboardHome-title
    {
        width: 100%;
        font-size: 13px;
        background-color: #fff;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .ivu-col-span-6
    {
        margin-bottom: 20px;
    }
    .ivu-col-span-12
    {
        margin-bottom: 20px;
    }
    .ivu-col-span-24
    {
        margin-bottom: 20px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
    }
    .main-top
    {
        width: 100%;
        height: 150px;
        background-color: #47bac1;
        margin-bottom: 0px;
    }
    .main-bottom
    {
        width: 100%;
        min-height: 213px;
        padding:10px;
        margin-bottom: 0px;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        float:left;
        color:#000;
    }
    .event
    {
        font-size:13px;
        font-weight: 600;
        float:left;
        color:#000;
        padding-left: 9px;
        margin-top: 10px;
    }
    .moreDetail
    {
        float: right;
        margin-top: 10px;
        margin-right: 5px;
        cursor: pointer;
    }
    .allSize
    {
        font-size:12px;
    }
    .main-bottom-number
    {
        font-weight: bold;
        height: 28px;
        font-size:16px;
        margin-top: -13px;
    }
    .main-second-title
    {
        width: 100%;
        min-height: 53px;
        float:left;
        padding: 0;
        text-align: center;
    }
    .main-bottom-title
    {
        margin-bottom: 10px;
        font-size: 13px;
        font-weight: 600;
    }
    .main-bottom-content
    {
        width: 100%;
        min-height: 53px;
        float:left;
        padding: 0;
        text-align: center;
        margin-top: 10px;
        font-size:17px;
    }
    .main-top-title-left
    {
        padding: 13px;
        font-size: 25px;
        float: left;
        color:#fff;
    }
    .main-top-title-right{
        font-size: 12px;
        line-height: 71px;
        color: #3c3b3b;
    }
    .main-bottom-bar
    {
        height: 60px;
        margin-bottom: 0px;
        width: 100%;
    }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
</style>




// WEBPACK FOOTER //
// src/components/dashboardHome/DashboardHome.vue